import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useRef, useState } from 'react';

import Slider from 'react-slick';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { SliderArrow } from 'Components/SliderArrow';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const SliderContainer = styled.div`
  --side-padding: 1vw;

  position: relative;

  padding: 0 var(--side-padding);

  width: 100%;
  max-width: calc(1280px + 2 * var(--side-padding));
  margin: 0 auto;

  ${legacyTheme.breakpoints.up('md')} {
    height: 95%;
  }
`;

const DesktopSlider = styled(Slider)`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .slick-dots {
    position: initial;
    display: flex !important;
    align-items: center;
    padding: 20px 8px;
    li {
      flex: 1;
      width: 100%;
      margin: 0;
    }
    li:first-of-type > div {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    li:last-of-type > div {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    ${legacyTheme.breakpoints.up('sm')} {
      padding: 14px 8px;
    }
    ${legacyTheme.breakpoints.up('md')} {
      padding: 14px 8px;
    }
  }
  .slick-track .slick-slide {
    padding: 0 9px;
  }
  .slick-dots {
    padding: 0 8px;
  }
  .slick-dots li {
    height: 0px;
    margin: 0px;
  }
  .slick-arrow {
    top: 45%;
  }
  .slick-prev,
  .slick-next {
    width: 10px;
    height: auto;
  }
  .slick-prev {
    left: calc(-0.7 * var(--side-padding));
  }
  .slick-next {
    right: calc(-0.7 * var(--side-padding));
  }
  .slick-prev:before,
  .slick-next:before {
    display: none;
  }
`;

const Dot = styled('div')<{ currentSlide: number; index: number }>`
  width: 100%;
  height: 5px;
  background: ${theme.colors.primary[300]};
  opacity: ${(props) => (props.currentSlide === props.index ? '1' : '0.15')};
`;

type DesktopCustomSliderProps = {
  cards: any;
};

const sliderArrowProps = { leftAndRight: 2, top: 38 };

export const ProductsDesktopAndTabletCustomSlider = ({ cards }: DesktopCustomSliderProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { isDesktop } = useResponsiveVariant();
  const slidesToShow = 3;

  const customPaging = (i: number) => <Dot currentSlide={currentSlide} index={i} />;
  const showNextArrow = currentSlide !== cards.length - slidesToShow;
  const showPreviousArrow = currentSlide > 0;

  const sliderRef = useRef<Slider>(null);
  return (
    <SliderContainer>
      {isDesktop && showPreviousArrow && (
        <SliderArrow
          direction="prev"
          leftAndRight={sliderArrowProps.leftAndRight}
          onClick={() => sliderRef?.current?.slickPrev()}
          top={sliderArrowProps.top}
        />
      )}
      <DesktopSlider
        ref={sliderRef}
        afterChange={(slide: number) => setCurrentSlide(Math.round(slide))}
        arrows={false}
        customPaging={customPaging}
        dots
        infinite={false}
        slidesToScroll={1}
        slidesToShow={slidesToShow}
      >
        {cards}
      </DesktopSlider>
      {isDesktop && showNextArrow && (
        <SliderArrow
          direction="next"
          leftAndRight={-sliderArrowProps.leftAndRight}
          onClick={() => sliderRef?.current?.slickNext()}
          top={sliderArrowProps.top}
        />
      )}
    </SliderContainer>
  );
};
